#import "../fragments/meeting-stub-fragment.graphql"

query GetMeetings($entityIds: [ID!], $archived: Boolean, $meetingTypes: [MeetingType!]) {
    meetings(entityIds: $entityIds, archived: $archived, meetingTypes: $meetingTypes) {
        ...MeetingStubFragment
    }
}
